import type { CodebaseProductData, productDescription } from '../types/models';
import { resolveRegionValue } from '@/composables/regionHelpers';
import { productCardBadgesBySku } from '@/features/Page/data/globalData';

type LocalisedContent = Omit<CodebaseProductData['content'], 'description'> & {
  description?: productDescription;
};

export const useStoreContentLocaliseHelper = (
  content: CodebaseProductData['content'],
  sku?: string,
): LocalisedContent => ({
  ...content,
  description: resolveRegionValue(content.description),
  productCardBadge:
    (sku ? resolveRegionValue(productCardBadgesBySku)?.[sku] : undefined) ??
    content.productCardBadge,
});
